import { createAsyncThunk } from "@reduxjs/toolkit";
import { type SupervisorDelivery } from "../../../domain/entities/supervisor-delivery";
import { type SupervisorDeliveryDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getDetail = createAsyncThunk<
  SupervisorDelivery,
  string,
  { dispatch: SupervisorDeliveryDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_DETAIL, async (requestId, { extra }) => {
  return await extra.supervisorDeliveryRepo.getDetail(requestId);
});
